import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ListStyles } from "../liststylebuttons/liststylebuttons";

@customElement("news-result-card")
export class SearchList extends LitElement {
  @property()
  accessor imageUrl = "";
  @property()
  accessor url = "";
  @property()
  accessor title = "";
  @property()
  accessor date = "";
  @property()
  accessor type = "";
  @property()
  accessor intro = "";
  @property()
  accessor isRegulatory = false;

  @property()
  accessor dictionary: any = {};

  @property()
  accessor culture: string = "";

  createRenderRoot() {
    return this;
  }

  renderImage(
    imageUrl: string | null,
    altText: string,
    cssClass: string,
    crop: string
  ) {
    if (imageUrl !== null && imageUrl !== "null" && imageUrl !== "") {
      return html`<img
        class="${cssClass}"
        src="${imageUrl}?${crop}"
        alt="${altText}"
      />`;
    } else {
      return html`<img
        class="${cssClass}"
        src="/images/placeholders/newsplaceholderImage.png"
        alt="${altText}"
      />`;
    }
  }
 
  renderDate() {
    if (this.date != null && this.date != "") {
      var d = new Date(this.date);
      var monthName = d.toLocaleString(this.culture, { month: "short" });
      var monthDate = d.getDate();
      var year = d.getFullYear();
      return html`<time
        class="
      absolute top-0  flex flex-col items-center justify-center gap-1
          w-[92px] h-[102px] md:w-[122px] md:h-[120px]
          bg-light-grey-10 text-grey-100 px-2.5"
        datetime="${this.date}"
      >
        <span
          class="block text-center uppercase text-[54px] md:text-[71.834px] font-medium tracking-[1.08px] leading-none"
        >
          ${monthDate}
        </span>
        <span
          class="block text-center uppercase text-[14px] md:text-[18px] font-medium tracking-[1.49px] leading-snug"
        >
          ${monthName} 
          <!-- <span class="block sm:inline">${year}</span> -->
        </span>
      </time>`;
    } else {
      return html``;
    }
  }
  renderDateText() {
    if (this.date != null && this.date != "") {
      var d = new Date(this.date);
      const options: Intl.DateTimeFormatOptions = {
        day: "2-digit",
        month: "short",
        year: "numeric",
      };
      const formattedDate: string = d.toLocaleDateString("en-GB", options);

      const formattedTime: string = d.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      return html`<time class="block" datetime="${this.date}">
        <span class="text-[16px] md:text-[18px]"> ${formattedDate} ${formattedTime} </span>
      </time>`;
    } else {
      return html``;
    }
  }

  renderCard() {
    const baseStyle = "relative bg-blue-10 col-span-4  max-w-[820px]";

    this.className = baseStyle + " md:col-span-4 md:px-0 md:mx-auto md:w-full";
    return html`
      <a
        class="block group bg-blue-10 md:flex md:min-h-full"
        href="${this.url}"
      >
        ${this.renderDate()}
        ${this.renderImage(
          this.imageUrl,
          this.title,
          "w-full aspect-[292/272] md:w-[292px] md:h-[272px] object-cover",
          ""
        )}
        <div
          class="p-6 md:px-8 md:py-6  md:flex-1 flex flex-col justify-between"
        >
          <div class="flex-1">
            <span class=" mb-4 flex justify-between">
              <span class="tag">${this.type}</span>
              ${this.isRegulatory
                ? html`<span class="text-dark-blue-100 tag "
                    >${JSON.parse(this.dictionary)["regulatory"] ??
                    "Regulatory"}</span
                  >`
                : ""}
            </span>           
            <span
              class="h5 mb-3 text-darker-blue-100 line-clamp-4"
              title="${this.title}"
            >
              ${this.title}
            </span>
            <!-- <p class="p mb-3 line-clamp-2">
              <span title="${this.intro}"
                >${this.intro}</span
              >
            </p> -->
          </div>
          <p class="p flex justify-between">
            <span class="text-dark-blue-100">${this.renderDateText()}</span>

            <span class="underline group-hover:text-darker-blue-100 "
              >${JSON.parse(this.dictionary)["readmore"] ?? ""}</span
            >
          </p>
        </div>
      </a>
    `;
  }
  render() {
    return html`${this.renderCard()} `;
  }
}
